import React, { useEffect, useState } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash, faCircleLeft, faFloppyDisk } from '@fortawesome/free-solid-svg-icons'
import { fetchWspolnotaWazneNumery } from "../../Redux/Actions";
import { useDispatch } from 'react-redux';
import DialogYesNo from "../DialogYesNo.js";

const WspolnotyWazneNumeryLista = props => {

    const { wazneNumery, setActiveWindow, idw } = props;

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false)
    const [removeId, setRemoveId] = useState(0);

    const usunWpis = async id => {
        await axios.post('/api/wspolnota/wazne-numery/usun', {
            id: id
          }).then( (res) => {
            dispatch(fetchWspolnotaWazneNumery(idw)); 
          }).catch( err => {
            console.log(err);
          })
    }
    console.log(wazneNumery)
    const handleUsun = id => {
        setRemoveId(id)
        setOpen(true);
    }
    
    const listaNumery = wazneNumery?.length > 0 && wazneNumery?.map ( (wpis, i) => (
            <li
                key={i} 
                // onClick={ ( ) => handleWybranaUlica(ulica.id) } 
                className="pointer"
                // style={ wybranaUlica == ulica.id ? {"backgroundColor": "var(--podswietlenie)"} : {} }
            >
                <div>
                    {`${wpis.numer} : ${wpis.opis}`}
                </div>
                <div 
                    style={{"textAlign": "right"}}
                    className="pointer"
                    onClick={()=>handleUsun(wpis?.id)}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </div>
            </li>
        )
    )

    const handleClick = () => setActiveWindow("dodaj");

    return (
        <div className="wspolnotyUliceLista">
            <div className="naglowek">
                <h3>
                    Lista ważnych numerów 
                </h3>
                <FontAwesomeIcon 
                    icon={faPlus}
                    className="pointer" 
                    onClick={handleClick}
                />
            </div>
            { listaNumery && listaNumery?.length > 0 ? (
                    <ul className="uliceLista">
                        {listaNumery}
                    </ul>
                ) : (<h4>Brak numerów</h4>) 
            }   
            <DialogYesNo 
                open={open}
                setOpen={setOpen}
                message={"Czy na pewno chcesz usunąć tn numer?"}
                f={usunWpis}
                id={removeId}
            />         
        </div>
    )
}

export default WspolnotyWazneNumeryLista;